const menu = ['promotions', 'featured', 'top', 'all', 'pricing']

export default menu
